interface Props {
  image: React.ReactNode;
  title: string;
  text: string;
  children?: React.ReactNode
}


export default function HeaderSection({image, title, text, children}: Props) {
  return (
    <section className="xl:w-6/12 sm:w-10/12 w-11/12 m-auto">
      <div className="flex flex-col items-center gap-5">
        {image}
        <h1 className="h1 text-primary mt-8">{title}</h1>
        <p className="paragraph text-center leading-8">
          {text}
        </p>
        {children}
      </div>
    </section>
  )
}
